export default __webpack_public_path__ + "static/media/babyNameFinderProject.b20b81c5.jpg";